import React from 'react';

import Classes from './BannerButton.module.scss';

type TBannerButtonProps = {
  bannerPositionId: string;
};

const BannerButton = ({ bannerPositionId }: TBannerButtonProps) => {
  return <div id={bannerPositionId} className={Classes.box} />;
};

export default BannerButton;
